<div class="portal-page">

	<!-- Top bar -->
	<portal-header mode="section" [projectId]="projectId" current="invoices" [sections]="sections"></portal-header>

	<portal-loader *ngIf="loading"></portal-loader>
	<div class="sec-state portal-error" *ngIf="error">{{ error }}</div>

	<ng-container *ngIf="!loading && !error">

		<!-- Summary -->
		<portal-project-totals [projectId]="projectId"></portal-project-totals>

		<!-- Filter tabs -->
		<div class="sec-filter-tabs">
			<button class="portal-pill" [class.active]="filter === 'all'" (click)="filter = 'all'">
				All <span class="portal-pill-count">{{ counts.all }}</span>
			</button>
			<button class="portal-pill" [class.active]="filter === 'unpaid'" (click)="filter = 'unpaid'">
				Unpaid <span class="portal-pill-count">{{ counts.unpaid }}</span>
			</button>
			<button class="portal-pill" [class.active]="filter === 'paid'" (click)="filter = 'paid'">
				Paid <span class="portal-pill-count">{{ counts.paid }}</span>
			</button>
			<label class="sec-search-pill">
				<i class="wq wq-search"></i>
				<input type="text" placeholder="Search" [(ngModel)]="search">
			</label>
		</div>

		<!-- Invoice rows -->
		<div class="sec-list">
			<p class="sec-state" *ngIf="!filtered.length">No invoices to show.</p>

			<div class="inv-row inv-grid" *ngFor="let inv of filtered">
				<!-- Mobile-only status line -->
				<div class="inv-status-dot-row">
					<div class="inv-status-dot" [style.background]="inv.status === 'paid' ? 'var(--c-success-solid)' : 'var(--c-primary-solid)'"></div>
					<span class="inv-status-label">{{ inv.status === 'paid' ? 'Paid' : 'Unpaid' }}</span>
				</div>

				<!-- Col 1 — ref + title (amount stacked here on mobile) -->
				<div class="inv-title-row">
					<div class="inv-title-col">
						<div class="inv-ref">
							#{{ inv.invoice_no }}
							<span class="inv-type-badge" *ngIf="inv.is_deposit">Deposit</span>
						</div>
						<div class="inv-title">{{ inv.description || 'Invoice' }}</div>
					</div>
					<div class="inv-amount-col">
						<div class="inv-amount-val">{{ inv.subtotal | currency:inv.currency_id }}</div>
						<div class="inv-amount-lbl">exclude Tax</div>
					</div>
				</div>

				<!-- Col 2 (desktop) — status badge + due, then amount -->
				<div class="inv-col2">
					<div class="inv-col2-top">
						<span class="badge" [ngClass]="inv.status === 'paid' ? 'badge-success' : 'badge-primary'">{{ inv.status === 'paid' ? 'Paid' : 'Unpaid' }}</span>
						<span class="inv-valid-until" *ngIf="inv.status !== 'paid'">{{ dueLabel(inv) }}</span>
					</div>
					<div class="inv-col2-bottom">
						<div class="inv-amount-val">{{ inv.subtotal | currency:inv.currency_id }}</div>
						<div class="inv-amount-lbl">exclude Tax</div>
					</div>
				</div>

				<!-- Col 3 — payment summary -->
				<div class="inv-payment">
					<div class="inv-payment-label">Payment Summary</div>
					<div class="inv-payment-amount-row">
						<div class="inv-payment-big">{{ inv.paid | currency:inv.currency_id }}</div>
						<div class="inv-payment-of">of {{ inv.subtotal | currency:inv.currency_id }} Paid so far</div>
					</div>
					<portal-progress-bar size="md" [paid]="inv.paid" [toPay]="inv.to_pay" [total]="inv.subtotal"></portal-progress-bar>
					<div class="inv-payment-legend">
						<div class="inv-legend-item">
							<div class="inv-legend-dot-row"><div class="inv-legend-dot" style="background:var(--c-success-solid);"></div> Paid so far <span class="inv-legend-pct">{{ pctOf(inv.paid, inv.subtotal) }}%</span></div>
							<div class="inv-legend-val">{{ inv.paid | currency:inv.currency_id }}</div>
						</div>
						<div class="inv-legend-item right">
							<div class="inv-legend-dot-row"><div class="inv-legend-dot" style="background:var(--c-primary-solid);"></div> To pay now <span class="inv-legend-pct">{{ pctOf(inv.to_pay, inv.subtotal) }}%</span></div>
							<div class="inv-legend-val">{{ inv.to_pay | currency:inv.currency_id }}</div>
						</div>
					</div>
				</div>

				<!-- Col 4 — actions -->
				<div class="inv-btns">
					<!-- Reachable in a staff preview: the invoice page is read-only, records no view, and
					     opens by its own tokenised URL, so it needs no portal session. Only Pay now is held
					     back, because ?mode=pay drops straight into the live payment flow. -->
					<portal-button (click)="openInvoice(inv)" [disabled]="!inv.invoice_url" [title]="inv.invoice_url ? null : 'Invoice not available to view'">Invoice Details</portal-button>
					<portal-button *ngIf="inv.status !== 'paid'" (click)="payInvoice(inv)" [disabled]="preview.ready || !inv.pay_url" [title]="preview.ready ? preview.blockedReason : (inv.pay_url ? null : 'Online payment is not available for this invoice')">Pay now</portal-button>
				</div>
			</div>
		</div>

		<!-- Footer -->
		<portal-project-footer [projectId]="projectId"></portal-project-footer>

	</ng-container>
</div>
